<template>
  <Modal v-model="addReceivingAccountModal" :title="addReceivingAccountTitle"
    :transfer="false" :mask-closable="false" width="600" @on-visible-change="addReceivingAccountChange">
    <Form ref="addReceivingAccountForm" :model="addReceivingAccountForm" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
      <Row style="width: 80%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1004303')" prop="channel">
            <Input clearable v-model.trim="addReceivingAccountForm.channel" :placeholder="$t('key1004611')"></Input>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1004304')" prop="account">
            <Input clearable v-model.trim="addReceivingAccountForm.account" :placeholder="$t('key1004612')"></Input>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1004613')" prop="currency">
            <Select v-model="addReceivingAccountForm.currency" transfer filterable>
              <Option v-for="(item, index) in currencyList" :key="index" :value="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1004614')" prop="remark">
            <Input type="textarea" :showWordLimit="true" :maxlength="200"
              :autosize="{ minRows: 5, maxRows: 8}" v-model.trim="addReceivingAccountForm.remark">
            </Input>
          </Form-item>
        </Col>
        <p class="ml54">
          {{ $t('key1000615') }}<br/>
          {{ $t('key1004615') }}
        </p>
      </Row>
    </Form>
    <template #footer>
      <Button @click="addReceivingAccountModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="addReceivingAccountBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getCurrencyData} from "@/utils/common";

export default {
  name: 'addReceivingAccountModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      addReceivingAccountModal: false,
      addReceivingAccountTitle: '',
      addReceivingAccountType: null,
      addReceivingAccountForm: {
        account: null,
        channel: null,
        currency: null,
        remark: null,
      },
      ruleValidate: {
        account: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004607'), trigger: 'blur'},
        ],
        channel: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004608'), trigger: 'blur'}
        ],
        currency: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004609'), trigger: 'change'}
        ],
      },
      currencyList: []
    };
  },
  methods: {
    // 初始化数据
    initAddReceivingAccountData(type, ymsReceivePayAccountId) {
      getCurrencyData().then((data) => {
        this.currencyList = data;
        let obj = {
          add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004305'),
          edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004610')
        };
        this.addReceivingAccountTitle = obj[type];
        this.addReceivingAccountType = type;
        if (type === 'add') {
          this.addReceivingAccountModal = true;
        } else {
          this.getReceivingAccountDetails(ymsReceivePayAccountId);
        }
      });
    },
    // 获取收款账户详情数据
    getReceivingAccountDetails(ymsReceivePayAccountId) {
      this.axios.get(api.get_ymsReceivePayAccount_detail + ymsReceivePayAccountId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            for (let key in this.addReceivingAccountForm) {
              this.addReceivingAccountForm[key] = data[key];
              this.addReceivingAccountForm.ymsReceivePayAccountId = data.ymsReceivePayAccountId;
            }
          }
          this.addReceivingAccountModal = true;
        }
      });
    },
    // 确定
    addReceivingAccountBtn() {
      let v = this;
      let text = '';
      let method = null;
      let url = '';
      let query = Object.assign({}, v.addReceivingAccountForm);
      if (v.addReceivingAccountType === 'add') {
        url = api.post_ymsReceivePayAccount_create;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000776');
        method = 'post';
      } else {
        url = api.put_ymsReceivePayAccount_update;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001205');
        method = 'put';
      }
      v.$refs['addReceivingAccountForm'].validate((valid) => {
        if (valid) {
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.addReceivingAccountModal = false;
              v.$Message.success(text);
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    addReceivingAccountChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.$refs['addReceivingAccountForm'].resetFields();
        });
      }
    }
  },
};
</script>

<style lang="less">

</style>
